import { Link, Outlet } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'

export function Shell() {
  const { me, loading, error, canSignOut, signOut, correlationId } = useAuth()

  return (
    <div className="shell">
      <header className="shell-header">
        <Link to="/" className="wordmark">
          <span className="wordmark-mark" aria-hidden="true" />
          Kurrawa Data Room
        </Link>

        <div className="shell-user">
          {me && (
            <>
              <div className="shell-user-name">
                <span>{me.displayName ?? me.userName ?? me.subject}</span>
                {me.email && <span className="shell-user-email">{me.email}</span>}
              </div>
              <ul className="chips" aria-label="Roles">
                {me.roles.map((role) => (
                  <li key={role} className="chip">
                    {role}
                  </li>
                ))}
              </ul>
            </>
          )}
          <button
            type="button"
            className="btn"
            onClick={signOut}
            disabled={!canSignOut}
            title={canSignOut ? 'End the session' : 'No session to end in stub mode'}
          >
            {canSignOut ? 'Sign out' : 'Sign out (dev stub)'}
          </button>
        </div>
      </header>

      <main className="shell-main wide">
        {loading && <p className="muted">Signing you in…</p>}
        {error && (
          <div className="alert alert-error" role="alert">
            <p className="alert-title">The API refused the sign-in.</p>
            <p>{error.message}</p>
            {correlationId && <p className="mono small">Correlation id: {correlationId}</p>}
          </div>
        )}
        {me && <Outlet />}
      </main>

      <footer className="shell-footer">
        {canSignOut ? 'Signed in via Keycloak' : 'Development stub'}
      </footer>
    </div>
  )
}
